export const keralaFestivals = {
  Jan: [
    {
      name: 'Makara Vilakku',
      location: 'Sabarimala',
      highlights: [
        'Celebrated at Sabarimala',
        'Millions of pilgrims visit the shrine',
        'Major attraction: Makara Jyothi',
        "Arthunkal St. Andrew's Basilica (Makaram Perunnal)"
      ]
    },
    {
      name: 'Christmas–New Year Tourism Season',
      location: 'Alappuzha, Kumarakom, Munnar, Kovalam',
      highlights: [
        'Peak tourism period continues into January',
        'Popular for backwaters, hill stations, and beaches'
      ]
    }
  ],
  Feb: [
    {
      name: 'Attukal Pongala',
      location: 'Thiruvananthapuram',
      highlights: [
        "One of the world's largest gatherings of women",
        'Devotees prepare Pongala offering in earthen pots'
      ]
    },
    {
      name: 'Maha Shivaratri',
      location: 'Aluva Manappuram',
      highlights: [
        'Major celebrations along the Periyar riverbanks',
        'Thousands of devotees gather for rituals and offerings'
      ]
    },
    {
      name: 'Chettikulangara Bharani',
      location: 'Chettikulangara Devi Temple, Mavelikkara',
      highlights: [
        'Spectacular temple festival during Malayalam month Kumbham',
        'Dedicated to Goddess Bhagavathy',
        'Attracts lakhs of devotees from across Kerala and beyond'
      ]
    }
  ],
  Mar: [
    {
      name: 'Kodungallur Bharani',
      location: 'Kodungallur',
      highlights: [
        'Famous temple festival',
        'Traditional rituals and cultural performances'
      ]
    },
    {
      name: 'Temple Festival Season Begins',
      location: 'Across Kerala',
      highlights: [
        'Elephant processions',
        'Panchavadyam',
        'Chenda Melam',
        'Fireworks'
      ]
    },
    {
      name: 'Ambalappuzha Arattu',
      location: 'Ambalappuzha Sree Krishna Temple',
      highlights: [
        'Renowned Arattu festival with caparisoned elephants',
        'Famous for the tradition of Paal-Paayasam offering',
        'Major cultural draw in Alappuzha district'
      ]
    }
  ],
  Apr: [
    {
      name: 'Vishu',
      location: 'Statewide',
      highlights: [
        'Vishukkani',
        'Vishukkaineettam',
        'Traditional Sadya'
      ]
    },
    {
      name: 'Thrissur Pooram',
      location: 'Thrissur',
      highlights: [
        "Kerala's most famous temple festival",
        'Decorated elephants',
        'Panchavadyam and fireworks'
      ]
    }
  ],
  May: [
    {
      name: 'Temple Festival Season Peak',
      location: 'Across Kerala',
      highlights: [
        'Arattupuzha Pooram',
        'Peruvanam Pooram',
        'Kottiyoor Festival',
        'Large cultural gatherings across Kerala'
      ]
    }
  ],
  Jun: [
    {
      name: 'Monsoon Tourism Begins',
      location: 'Alappuzha, Kumarakom, Munnar',
      highlights: [
        'Lush green backwaters, paddy fields, and coconut groves',
        'Ayurvedic treatments',
        'Backwater tourism and houseboat holidays',
        'Scenic monsoon season (June–September)'
      ]
    }
  ],
  Jul: [
    {
      name: 'Champakulam Moolam Boat Race',
      location: 'Champakulam',
      highlights: [
        'Oldest boat race in Kerala',
        'Traditional snake boats compete'
      ]
    },
    {
      name: 'Monsoon Festivals',
      location: 'Across Kerala',
      highlights: [
        'Village temple festivals',
        'Folk performances'
      ]
    }
  ],
  Aug: [
    {
      name: 'Nehru Trophy Boat Race',
      location: 'Punnamada Lake, Alappuzha',
      highlights: [
        "Kerala's most famous boat race",
        'Held on Punnamada Lake',
        'Traditional snake boats compete'
      ]
    },
    {
      name: 'Onam',
      location: 'Statewide',
      highlights: [
        'Biggest festival in Kerala',
        'Celebrates King Mahabali',
        'Pookalam, Onasadya, Pulikali, Vallamkali, Thiruvathira'
      ]
    }
  ],
  Sep: [
    {
      name: 'Onam Celebrations Continue',
      location: 'Across Kerala',
      highlights: [
        'Tourism peak season',
        'Houseboats and homestays experience high occupancy'
      ]
    }
  ],
  Oct: [
    {
      name: 'Navaratri & Saraswathi Pooja',
      location: 'Statewide',
      highlights: [
        'Vidyarambham (initiation of children into learning)',
        'Book worship ceremonies',
        'Music and dance programs'
      ]
    }
  ],
  Nov: [
    {
      name: 'Kalpathi Ratholsavam',
      location: 'Palakkad',
      highlights: [
        'Famous festival in Palakkad',
        'Traditional temple chariot procession'
      ]
    },
    {
      name: 'Sabarimala Pilgrimage Season Begins',
      location: 'Sabarimala',
      highlights: [
        'Lakhs of devotees travel through Kerala',
        'Major pilgrimage season through the Western Ghats'
      ]
    }
  ],
  Dec: [
    {
      name: 'Christmas',
      location: 'Statewide',
      highlights: [
        'Major celebrations throughout Kerala',
        'Church festivals and cultural events'
      ]
    },
    {
      name: 'New Year Celebrations',
      location: 'Alappuzha, Kumarakom, Kochi, Munnar',
      highlights: [
        'Popular year-end tourism destinations',
        'Beach and backwater celebrations'
      ]
    },
    {
      name: 'Kochi Carnival',
      location: 'Fort Kochi',
      highlights: [
        'Colourful year-end carnival festivities',
        'Parades, cultural programs, and beach events'
      ]
    }
  ]
};
